<template>
  <!-- Category Section -->
  <section class="py-16 bg-white">
    <div class="container mx-auto px-4">
      <div class="text-center mb-10">
        <h2 class="text-3xl font-bold mb-2 text-[#B89666]">Iščite strokovnjake po področjih</h2>
        <p class="text-gray-600">Iščite s pomočjo interaktivne mape in najdite najboljšega strokovnjaka za vaše potrebe glede na vašo lokacijo.</p>
      </div>
      <div class="flex flex-wrap gap-6 mx-auto justify-center">
        <div 
          @click="submit(category.value)"
          v-for="category in categories" 
          :key="category.title + '-flex'" 
          class="bg-blue-50 rounded-lg p-4 flex flex-col items-center shadow hover:shadow-lg transition cursor-pointer max-w-[200px]"
        >
          <img :src="category.icon" :alt="category.icon_alt" :title="category.icon_title" class="h-12 w-12 mb-3" />
          <h6 class="font-semibold mb-1">{{ category.title }}</h6>
          <p class="text-xs text-gray-500 mb-2">{{ category.description }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { router, usePage } from '@inertiajs/vue3'

const submit = (cbt) => {
  router.get(route('web.search'), {
    cbt: cbt
  })
}

const page = usePage();

const categories = [
  { 
    title: 'Odvetniki', 
    listings: '9874', 
    icon: '/images/icons/lawyer.svg', 
    icon_alt: 'Odvetniki',
    icon_title: 'Odvetniki',
    value: 'law_office' ,
    description: 'Pravni nasveti in zastopanje po meri'
  },
  { 
    title: 'Notarji', 
    listings: '787', 
    icon: '/images/icons/notary.svg', 
    icon_alt: 'Notarji',
    icon_title: 'Notarji',
    value: 'notary',
    description: 'Hitre overitve in varno urejene pogodbe'
  },
  { 
    title: 'Cenilci', 
    listings: '2357', 
    icon: '/images/icons/appraiser.svg', 
    icon_alt: 'Cenilci',
    icon_title: 'Cenilci',
    value: 'appraiser',
    description: 'Zanesljive ocene vrednosti nepremičnin in podjetij' 
  },
  { 
    title: 'Stečajni upravitelji', 
    listings: '1260', 
    icon: '/images/icons/liquidator.svg', 
    icon_alt: 'Stečajni upravitelji',
    icon_title: 'Stečajni upravitelji',
    value: 'liquidator',
    description: 'Strokovno vodenje stečajev, prisilnih poravnav in likvidacij' 

  },
  {
    title: 'Sodni izvedenec',
    listings: '1260',
    icon: '/images/icons/court_expert.svg',
    icon_alt: 'Sodni izvedenec',
    icon_title: 'Sodni izvedenec',
    value: 'court_expert',
    description: 'Strokovno vodenje stečajev, prisilnih poravnav in likvidacij'
  },
  {
    title: 'Sodni tolmač',
    listings: '1260',
    icon: '/images/icons/interpreter.svg',
    icon_alt: 'Sodni tolmač',
    icon_title: 'Sodni tolmač',
    value: 'court_interpreter',
    description: 'Strokovno vodenje stečajev, prisilnih poravnav in likvidacij'
  },
  {
    title: 'Izvršitelj',
    listings: '1260',
    icon: '/images/icons/enforcement_officer.svg',
    icon_alt: 'Izvršitelj',
    icon_title: 'Izvršitelj',
    value: 'enforcement_officer',
    description: 'Strokovno vodenje stečajev, prisilnih poravnav in likvidacij'
  },
  {
    title: 'Poravnalec',
    listings: '1260',
    icon: '/images/icons/settlement_mediator.svg',
    icon_alt: 'Poravnalec',
    icon_title: 'Poravnalec',
    value: 'settlement_mediator',
    description: 'Strokovno vodenje stečajev, prisilnih poravnav in likvidacij'
  },
];
</script>